import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import Logo from "@/components/Logo";

export default function AdminLogin() {
    const { user, login } = useAuth();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    if (user) return <Navigate to={user.role === "admin" ? "/admin" : "/me"} replace />;

    const onSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const res = await login(email, password);
        setLoading(false);
        if (res.ok) { toast.success("Sesión iniciada"); navigate("/admin"); }
        else toast.error(res.error);
    };

    return (
        <div className="min-h-screen grid md:grid-cols-2">
            <div className="hidden md:block bg-foreground text-background p-12 relative">
                <Logo variant="seal-light" size={140} />
                <div className="overline text-background/60 mt-12">Panel Administrativo</div>
                <h1 className="font-display text-6xl leading-none mt-6 tracking-tighter">
                    Hacienda<br/>Nápoles.
                </h1>
                <div className="absolute bottom-12 left-12 right-12 text-xs opacity-70">
                    Control total sobre proveedores, precios, temporadas, leads y aniversarios.
                </div>
            </div>
            <div className="flex items-center justify-center p-8 md:p-16">
                <form onSubmit={onSubmit} className="w-full max-w-sm space-y-6" data-testid="admin-login-form">
                    <div>
                        <div className="overline text-muted-foreground">Acceso interno</div>
                        <h2 className="font-display text-4xl mt-2 tracking-tighter">Inicia sesión</h2>
                    </div>
                    <div>
                        <Label className="overline text-muted-foreground">Email</Label>
                        <Input
                            data-testid="login-email"
                            type="email"
                            required
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="mt-2 rounded-none border border-border bg-white focus-visible:ring-0 focus-visible:border-foreground h-11"
                        />
                    </div>
                    <div>
                        <Label className="overline text-muted-foreground">Contraseña</Label>
                        <Input
                            data-testid="login-password"
                            type="password"
                            required
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="mt-2 rounded-none border border-border bg-white focus-visible:ring-0 focus-visible:border-foreground h-11"
                        />
                    </div>
                    <Button data-testid="login-submit" disabled={loading} className="w-full rounded-none bg-foreground text-background hover:bg-foreground/85">
                        {loading ? "Verificando…" : "Ingresar"}
                    </Button>
                </form>
            </div>
        </div>
    );
}
